import { render, staticRenderFns } from "./LayoutManagement.vue?vue&type=template&id=131ed2cf&scoped=true"
import script from "./LayoutManagement.vue?vue&type=script&lang=js"
export * from "./LayoutManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131ed2cf",
  null
  
)

export default component.exports